// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ItineraryPoint\ApiItineraryPointSelf.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthReservationSelf, BerthReservationSelfData, BerthReservationSelfOptions } from 'data/models/BerthReservationSelf';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { ItineraryPointVersion, ItineraryPointVersionData, ItineraryPointVersionOptions } from 'data/models/ItineraryPointVersion';

// ItineraryPointSelfData is the class that ItineraryPointSelf serializes to/from
export interface ItineraryPointSelfData {
    Id : number;
	
    BerthReservation : BerthReservationSelfData | null;
    Events : EventData[] | null;
    Live : ItineraryPointData | null;
    Versions : ItineraryPointVersionData[] | null;
	
}

// ItineraryPointSelfOptions is the class which may be passed to the ItineraryPointSelf constructor to define optional initial data values
export interface ItineraryPointSelfOptions {
    Id : number;
	
    BerthReservation? : BerthReservationSelfOptions | null;
    Events? : EventOptions[] | null;
    Live? : ItineraryPointOptions | null;
    Versions? : ItineraryPointVersionOptions[] | null;
	
}

export class ItineraryPointSelf {
    public Id : DataSignal<number>;
	
    public BerthReservation : DataSignal<BerthReservationSelf | null>;
    public Events : SDataArray<Event>;
    public Live : DataSignal<ItineraryPoint | null>;
    public Versions : SDataArray<ItineraryPointVersion>;
	

    constructor();
    constructor(data : ItineraryPointSelfOptions);
    constructor(data: ItineraryPointSelfOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BerthReservation = S.value<BerthReservationSelf | null>(null);
        this.Events = SArray<Event>([]);
        this.Live = S.value<ItineraryPoint | null>(null);
        this.Versions = SArray<ItineraryPointVersion>([]);
	    
    }

    static key(obj : ItineraryPointSelf) {
        return obj.Id();
    }
    
    static dataKey(obj : ItineraryPointSelfOptions) {
        return obj.Id;
    }

    static update(obj : ItineraryPointSelf, data : ItineraryPointSelfOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ItineraryPointSelf.ts